import { Colors, Lightning, Utils } from '@lightningjs/sdk'

export default class IconButton extends Lightning.Component {
  static _template() {
    return {
      ButnWrapper: {
        w: 210,
        h: 60,
        ButnBG: {
          w: 200,
          h: 60,
          rect: true,
          color: Colors('button')
            .alpha(0.4)
            .get(),
          shader: {
            type: Lightning.shaders.RoundedRectangle,
            fill: true,
            bodyColor: 'white',
            stroke: 3,
            w: 200,
            h: 60,
            radius: 30,
          },
        },
        ButnIcon: {
          x: 27,
          y: 60 / 2,
          w: 35,
          h: 35,
          mountY: 0.5,
          src: this.bindProp('buttonImage'),
        },
        ButnText: {
          x: 27 + 35 + 11,
          y: 60 / 2,
          h: 30,
          mountY: 0.5,
          color: 0xffffffff,
          text: {
            text: this.bindProp('buttonLabel'),
            fontSize: 25,
            fontFace: 'OpenSansBold',
            wordWrap: false,
            lineHeight: 30,
          },
        },
      },
    }
  }

  set buttonText(txt) {
    this._butnText = txt

    this.patch({
      buttonLabel: txt,
    })
  }

  set buttonType(tp) {
    this._butnType = tp

    if (tp.toLowerCase() === 'search') {
      this.buttonNormal = 'images/buttons/SearchIcon.png'
      this.buttonFocus = 'images/buttons/SearchIconF.png'
    }

    this.patch({
      buttonImage: Utils.asset(this.buttonNormal),
    })
  }

  get type() {
    return this._butnType
  }

  _init() {
    this.tag('ButnText').on('txLoaded', () => {
      const wd = this.tag('ButnText').renderWidth + 16 + 11

      this.tag('ButnWrapper').patch({
        w: wd + 104,
        ButnBG: { w: wd + 104 },
      })
    })
  }

  _focus() {
    this.patch({
      ButnWrapper: {
        ButnBG: {
          smooth: {
            'shader.fillColor': [
              Colors('buttonFocusBG').get(),
              { duration: 0.2, timingFunction: 'ease-in' },
            ],
            'shader.strokeColor': [
              Colors('white').get(),
              { duration: 0.2, timingFunction: 'ease-in' },
            ],
          },
        },
      },
      buttonImage: Utils.asset(this.buttonFocus),
    })
  }

  _unfocus() {
    this.patch({
      ButnWrapper: {
        ButnBG: {
          smooth: {
            'shader.fillColor': [
              Colors('button').get(),
              { duration: 0.2, timingFunction: 'ease-in' },
            ],
            'shader.strokeColor': [
              Colors('white')
                .alpha(0)
                .get(),
              { duration: 0.2, timingFunction: 'ease-in' },
            ],
          },
        },
      },
      buttonImage: Utils.asset(this.buttonNormal),
    })
  }
}
